import { ActionMenu } from 'components/menu/ActionMenu';
import { ActionMenuButton } from 'components/menu/ActionMenuButton';
import { ActionMenuTableCell } from 'components/menu/ActionMenuTableCell';

import type { FileActionsBaseProps } from './actions/base';
import { useFileActions } from './actions/base';
import { Delete } from './actions/Delete';
import { MakePrimary } from './actions/MakePrimary';
import { Move } from './actions/Move';
import { OpenFullSize } from './actions/OpenFullSize';
import { RenameFolder } from './actions/RenameFolder';
import { UnlinkGroup } from './actions/UnlinkGroup';

export type {
    ActiveAction,
    FileActionsBase,
    FileActionsBaseProps,
    FileIsh,
} from './actions/base';

export type FileLibraryActionsCellProps = FileActionsBaseProps;

export function FileLibraryActionsCell(props: FileLibraryActionsCellProps) {
    const base = useFileActions(props);

    const { mutate: openFullSize } = OpenFullSize.useMutation(base);
    const { mutate: confirmDelete } = Delete.useMutation(base);
    const { mutate: confirmUnlink } = UnlinkGroup.useMutation(base);
    const { mutate: makePrimary } = MakePrimary.useMutation(base);

    return (
        <ActionMenuTableCell>
            <ActionMenuButton
                onClick={base.popup.toggleOpen}
                ref={base.popup.triggerRef}
            />
            {base.popup.isOpen && (
                <ActionMenu
                    popupClassName="modal-popup"
                    onClose={base.popup.close}
                    ref={base.popup.popupRef}
                    buttonRef={base.popup.triggerRef}
                >
                    <OpenFullSize.MenuItem base={base} mutate={openFullSize} />
                    <MakePrimary.MenuItem base={base} mutate={makePrimary} />
                    <RenameFolder.MenuItem base={base} />
                    <Move.MenuItem base={base} />
                    <Delete.MenuItem base={base} />
                    <UnlinkGroup.MenuItem base={base} />
                </ActionMenu>
            )}
            {base.activeAction === 'delete' && (
                <Delete.Modal base={base} onConfirm={confirmDelete} />
            )}
            {base.activeAction === 'unlink-group' && (
                <UnlinkGroup.Modal base={base} onConfirm={confirmUnlink} />
            )}
            {base.activeAction === 'edit-folder' && <RenameFolder.Modal base={base} />}
            {base.activeAction === 'move' && <Move.Modal base={base} />}
        </ActionMenuTableCell>
    );
}
